import { NgModule } from '@angular/core';
import { SplitPaymentComponent } from './split-payment.component';
import { SharedModule } from '@shared/shared.module';
import { MatFormsModule } from '@shared/mat-forms/mat-forms.module';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [SplitPaymentComponent],
  imports: [SharedModule, MatFormsModule, MatSelectModule, MatIconModule],
  exports: [SplitPaymentComponent],
})
export class SplitPaymentModule {}
